import { useState, useEffect, useRef } from 'react';
import { getSecondsFromMin } from '../utils/time-helper';

export default function useCountdown(
  waitTimeMinutes: number,
  onDoTimeout: any,
  open: boolean = true,
) {
  const [counter, setCounter] = useState(getSecondsFromMin(waitTimeMinutes));
  const timerId: any = useRef();

  useEffect(() => {
    if (open) {
      timerId.current =
        counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    }
    return () => {
      timerId.current && clearInterval(timerId.current);
    };
  }, [counter, open]);

  const counterDone = counter === 0;
  useEffect(() => {
    if (counterDone) {
      timerId.current && clearInterval(timerId.current);
      setCounter(getSecondsFromMin(waitTimeMinutes));
      onDoTimeout();
    }
  }, [counterDone, onDoTimeout, waitTimeMinutes]);

  return { counter, setCounter };
}
